import { LinkType } from '@types'

export const whyCards = [
  {
    icon: '/badge-on.svg',
    title: 'Responsible Breeders',
    alt: 'Mawoo caring breeder certificate',
  },
  {
    icon: '/icons/health.svg',
    title: 'Health Guarantee',
    alt: 'Green search icon with a heart in the middle',
  },
  {
    icon: '/concierge-on.svg',
    title: 'Excellent Customer Service',
    alt: 'Concierge boy with heart icon on his vest',
  },
  {
    icon: '/icons/secure.svg',
    title: 'Secure and Simple Process',
    alt: 'lock and a shield icon',
  },
  {
    icon: '/travel-on.svg',
    title: 'Pickup & Delivery',
    alt: "Smiling girl with a dog sitting to her right and a heart icon above the dog's head",
  },
]

export const aboutUsLinks: LinkType[] = [
  { href: '/about-mawoo-pets', text: 'About Us', available: true },
  { href: '/mission', text: 'Our Mission', available: true },
  { href: '/why-mawoo-pets', text: 'Why Mawoo Pets?', available: true },
  { href: '/reviews', text: 'Customer Reviews', available: true },
  {
    href: '/health-guarantee-overview',
    text: 'Health Guarantee',
    available: true,
  },
  { href: '/puppy-travel', text: 'Puppy Travel', available: true },
  { href: '/insurance', text: 'Pet Insurance', available: true },
  {
    href: '/referral',
    text: 'Refer a Friend',
    available: false,
  },
  { href: '/faq/customer', text: 'FAQs', available: true },
  {
    href: '/contact',
    text: 'Contact Us',
    available: true,
  },
]
